import { DesignChannel } from 'components/NewFileModal/Types'
import { useSetExternalIntegration } from 'components/ArticlePostPreview/hooks'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { SchedulingDetails } from './SchedulingDetails'
import { PostDetails } from './PostDetails'
import { ReminderDetails } from './ReminderDetails'
import { PostOptionsPage } from './Types'
import { usePostPreviewContext } from './PostPreviewContext'

interface Props {
  fileId: string
  channel: DesignChannel
}

export const IntegrationActions = ({ fileId, channel }: Props) => {
  const integrationsQuery = useExternalIntegrations()
  const { page, scheduledPost, provider } = usePostPreviewContext()
  useSetExternalIntegration({ scheduledPost, integrationsQuery, provider })

  return (
    <>
      {page === PostOptionsPage.Schedule && <SchedulingDetails fileId={fileId} channel={channel} />}
      {page === PostOptionsPage.Reminder && <ReminderDetails />}
      {page === PostOptionsPage.PostDetails && <PostDetails fileId={fileId} channel={channel} />}
    </>
  )
}
